///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-answer-select')) {
      document.querySelector('.process-review-form').addEventListener('click', (e) => {
        const target = e.target;

        if (target.classList.contains('js-answer-select')) {
          const selectedAnswer = new SelectedAnswer(target);

          selectedAnswer.displayCommentNotice(target);

          target.addEventListener('input', function() {
            selectedAnswer.requireCommentAlert(target);
          });
        }
      });

      document.querySelector('.process-review-form').addEventListener('keyup', (e) => {
        const target = e.target;

        if (target.classList.contains('js-comment-field')) {
          const commentInput = new CommentInput(target);

          commentInput.clearCommentAlert(target);
        }
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function CommentInput(e) {
    this.commentNotice  = e.parentElement
                           .previousElementSibling
                           .querySelector('.js-comment-alert');

    this.selectedAnswer = e.parentElement
                           .parentElement
                           .previousElementSibling
                           .querySelector('.js-answer-select');
  }

  function SelectedAnswer(e) {
    this.commentField  = e.parentElement
                          .parentElement
                          .nextElementSibling
                          .querySelector('.js-comment-field');

    this.commentNotice = e.parentElement
                          .parentElement
                          .nextElementSibling
                          .querySelector('.js-comment-alert');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Toggles comment notice for No's
  //               based on associated comment field
  //               value
  //
  CommentInput.prototype.clearCommentAlert = function(e) {
    if (this.selectedAnswer && this.selectedAnswer.value == 'No') {
      if (e.value != '') {
        hideCommentNotice(e, this.commentNotice);
      } else if (e.value == '') {
        showCommentNotice(e, this.commentNotice);
      }
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Displays comment notice on
  //               page load for No's without
  //               an associated comment
  //
  SelectedAnswer.prototype.displayCommentNotice = function(e) {
    if (e.value == 'No' && this.commentField.value == '') {
      showCommentNotice(this.commentField, this.commentNotice);
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Show comment required alert
  //               and outline comment box
  //
  SelectedAnswer.prototype.requireCommentAlert = function(e) {
    if (e.value == 'No' && this.commentField.value == '') {
      showCommentNotice(this.commentField, this.commentNotice);
    } else if (e.value == 'Yes' || e.value == '') {
      hideCommentNotice(this.commentField, this.commentNotice);
    }
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Hide comment alert elements/stylings
  //
  function hideCommentNotice(commentField, commentNotice) {
    commentField.classList.remove('border', 'border-warning');
    commentNotice.classList.add('d-none');
  }

  ///////////////////////////////////////////////
  //
  // Description - Show comment alert elements/stylings
  //
  function showCommentNotice(commentField, commentNotice) {
    commentField.classList.add('border', 'border-warning');
    commentNotice.classList.remove('d-none');
  }
}());
